module.exports = __webpack_public_path__ + "files/71a441f43cf09c0ed25d06476fb61649.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/foods-1.png
// module id = 1465
// module chunks = 60